import { createFileRoute } from "@tanstack/react-router"

import { DashboardShell } from "@/components/dashboard-shell"
import { InsightsError } from "@/components/analytics/insights-error"
import { InventoryPage, InventoryProvider } from "@/components/inventory/inventory-panels"
import { InventoryLoadingSkeleton, RouteLoading } from "@/components/route-loading"

export const Route = createFileRoute("/inventory")({
  component: InventoryRoute,
  head: () => ({ meta: [{ title: "Inventory" }] }),
  pendingComponent: InventoryPending,
  errorComponent: ({ reset }) => <InsightsError page="Inventory" retry={reset} />,
})

// What we hand customers — QR standees, paper rolls, thermal printers, cables:
// how many we have and where (office, stores, teammates), what is out on free
// trial, what went out (sold, given free) and to whom. Paid sales are orders
// on the customer page; everything else that moves stock starts here.

function InventoryRoute() {
  return (
    <DashboardShell>
      <InventoryProvider>
        <InventoryPage />
      </InventoryProvider>
    </DashboardShell>
  )
}

function InventoryPending() {
  return (
    <RouteLoading>
      <InventoryLoadingSkeleton />
    </RouteLoading>
  )
}
